import { render, staticRenderFns } from "./ParameterFiles.vue?vue&type=template&id=2aefa7fa&scoped=true"
import script from "./ParameterFiles.vue?vue&type=script&lang=js"
export * from "./ParameterFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefa7fa",
  null
  
)

export default component.exports